import { useState } from 'react'

export default function ExampleComponent({ name = 'World' }) {
  const [count, setCount] = useState(0)

  return (
    <div>
      <p>Hello, {name}!</p>
      <button onClick={() => setCount(count + 1)}>Count: {count}</button>
    </div>
  )
}
